import { CurrencyOverrides } from '../../../shared/types/integrations/locale/currency/currency-overrides.type';

export const currencyOverrides: CurrencyOverrides = {
    'GBP': {
        overrides: '£',
        position: 'start',
    },
    'US$': {
        overrides: '$',
        position: 'end',
    },
};
